<script>

export default ({
  name: "logo"
})
</script>

<template>
  <div class="logo-group"><img src="@/assets/imags/logo.png" alt="资阳市博物馆"></div>
</template>

<style scoped lang="scss">

</style>
